'use strict';

angular.module('shared.services.tinymceConfigHelper', [])
    .service('tinymceConfigHelper', function () {
        var service = this;

        service.getTinyMceConfig = function (props) {
            var opts = angular.extend({}, {
                fonts: true,
                fontSize: false,
                fontFamily: false,
                formatting: true,
                lists: true,
                justify: true,
                tables: true,
                hyperlinks: true,
                images: true,
                undo: true,
                editHtml: true,
                height: 300,
                images_upload_handler: props.imagesUploadHandler,
            }, props);

            const plugins = ['lists', 'link', 'image', 'table', 'code', 'autoresize', 'contextmenu'];
            const toolbarItems = [];

            if (opts.fonts) {
                toolbarItems.push('styles');
            }
            if (opts.fontFamily) {
                toolbarItems.push('fontfamily');
            }
            if (opts.fontSize) {
                toolbarItems.push('fontsize');
            }

            if (toolbarItems.length > 0) toolbarItems.push('|');
            
            if (opts.formatting) {
                toolbarItems.push('bold italic underline strikethrough blockquote');
            }

            if (opts.lists) {
                toolbarItems.push('|', 'bullist numlist');
            }

            if (opts.justify) {
                toolbarItems.push('|', 'alignleft aligncenter alignright alignjustify', '|', 'indent outdent');
            }

            if (opts.hyperlinks) {
                toolbarItems.push('|', 'link unlink');
            }

            if (opts.images) {
                toolbarItems.push('|', 'image');
            }

            if (opts.tables) {
                toolbarItems.push('|', 'table');
            }

            if (opts.undo) {
                toolbarItems.push('|', 'undo redo');
            }

            if (opts.editHtml) {
                toolbarItems.push('|', 'code');
            }

            var options = {
                base_url: '/assets/scripts/tinymce/ng2',
                branding: false,
                menubar: false,
                plugins: plugins.join(' '),
                toolbar: toolbarItems.filter(Boolean).join(' '),
                height: opts.height,
                
                init_content_sync: true,

                style_formats: [
                    { title: 'Paragraph', block: 'p' },
                    { title: 'Heading 1', block: 'h1' },
                    { title: 'Heading 2', block: 'h2' },
                    { title: 'Heading 3', block: 'h3' },
                    { title: 'Heading 4', block: 'h4' },
                ],
                
                 // Better clipboard handling
                paste_block_drop: false,
                paste_data_images: true,
                paste_as_text: false,

                // Context menu without paste (use Ctrl+V for paste)
                // Paste from context menu is unreliable in TinyMCE 7.x even with clipboard permissions
                contextmenu: 'cut copy | link image table',

                default_link_target: '_blank',
                link_title: false,
                convert_urls: false,

                images_upload_handler: opts.images_upload_handler,
                images_reuse_filename: true,
                automatic_uploads: true,
                
                setup: function (editor) {
                    editor.on('BeforeSetContent', function (e) {
                        const content = e.content;
                        if (typeof content !== 'string') return;

                        const doc = new DOMParser().parseFromString(content, 'text/html');
                        const links = doc.querySelectorAll('a[href]');
                        
                        links.forEach(link => {
                            link.setAttribute('target', '_blank');
                            link.setAttribute('rel', 'noopener noreferrer'); 
                            
                            let href = link.getAttribute('href');
                            if (href && !/^(https?:\/\/|mailto:|tel:|\/|#)/.test(href)) {
                                link.setAttribute('href', 'http://' + href);
                            }
                        });
                        
                        e.content = doc.body.innerHTML;
                    });
                }
            };

            return options;
        };
    });
